import { BaseModel } from "sjs-base-model";
import CampaignMappingHitsModel from "./CampaignMappingHitsModel";

import CampaignMappingShardsModel from "./CampaignMappingShardsModel";

// get model for project
export default class CampaignMappingModel extends BaseModel {
  /*
   * Client-Side properties (Not from API)
   */
  // noneApiProperties = null;
  // response getting from the api mentioned end point

  _shards = { _shards: CampaignMappingShardsModel };
  current_page_no = 0;
  hits = { hits: CampaignMappingHitsModel };
  total_page_no = 0;

  constructor(data1) {
    super();

    this.update(data1);
  }
}
